import { SVGProps, Ref, forwardRef } from 'react';

export const AZSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M0 8a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v4H0z" fill="#0098C3" />
            <rect y={12} width={32} height={8} fill="#E00034" />
            <path d="M0 20h32v4a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" fill="#00AE65" />
            <path
                d="M12.64 16a2.93 2.93 0 0 0 5.106 1.962 3.516 3.516 0 1 1 0-3.924A2.93 2.93 0 0 0 12.64 16"
                fill="white"
            />
            <path
                d="m19.637 15.626 1.051.372-1.051.375.48 1.007-1.008-.478-.373 1.051-.375-1.05-.004.002-1.003.477.478-1.008-1.051-.372 1.051-.375-.48-1.007 1.006.476.003.002.372-1.051.375 1.05 1.007-.479z"
                fill="white"
            />
        </g>
    </svg>
));
AZSize32Glyph.displayName = 'AZSize32Glyph';
